import { Environment } from '../app/core/models/environment.model';

export const environment: Environment = {
  production: false,
  apiUrls: {
    identity: '/identity',
    notification: '/notification-api',
    bffUserPortal: '/bff-userportal-api',
  },
  auth: {
    issuer: 'https://qa.redrock.pro/identity',
    redirectUri: 'https://qa.redrock.pro/login/confirmation',
    clientId: 'frontend',
    dummyClientSecret: 'frontend_secret_rrp_240913',
    responseType: 'code',
    scope: 'openid frontend_api identity_api notification_api offline_access',
    tokenEndpoint: 'https://qa.redrock.pro/identity/connect/token',
    logoutUrl: 'https://qa.redrock.pro/identity/logout',
    postLogoutRedirectUri: 'https://qa.redrock.pro',
    requireHttps: false,
  },
  registrationUrl: 'https://qa.redrock.pro/identity/registration',
  observerLink: 'https://qa.redrock.pro/observer/',
  adminPanelUrl: 'https://admin-qa.redrock.pro',
  docsBaseUrl: 'https://qa.redrock.pro',
  captchaId: 'f5f35ac34f24adf02030b25817cb406f',
  startYearFnsReport: 2025,
};
